module.exports = __webpack_public_path__ + "PERUVIANserve-7.f140715c.png";